import { h } from 'preact';

function Icon({ children, fill = 'currentColor', stroke, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill={fill}
      stroke={stroke}
    >
      {children}
    </svg>
  );
}

export function IconFreeShipping({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <title>Free Shipping</title>
      <path
        fill="currentColor"
        d="M2 16.92H6V18.080000000000002H2z"
      ></path>
      <path
        fill="currentColor"
        d="M27.52 16.961l-2.087-4.218-.16-.323H20.58v-7H5.42v8.08h1.16V6.58h12.84v14.84h-7.505a2 2 0 00-3.83 0H6v1.16h2.085a2 2 0 003.83 0h10.17a2 2 0 003.83 0h1.665v-5.497l-.06-.122zM10 22.875a.875.875 0 110-1.75.875.875 0 010 1.75zm14 0a.875.875 0 110-1.75.875.875 0 010 1.75zm2.42-1.455h-.505a2 2 0 00-3.83 0H20.58v-7.84h3.973l1.867 3.774v4.066z"
      ></path>
      <path
        fill="currentColor"
        d="M1 18.92H6V20.080000000000002H1z"
      ></path>
      <path
        fill="currentColor"
        d="M3 14.92H6V16.08H3z"
      ></path>
    </Icon>
  );
}

export function IconCheck({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="7"
      width="8"
      viewBox="0 0 7 8"
    >
      <title>Check</title>
      <path
        fill="currentColor"
        d="M2.92 7.589L.289 4.916a1 1 0 111.424-1.403l.886.898L5.16.456A1 1 0 116.84 1.544L2.92 7.589z"
      ></path>
    </Icon>
  );
}

export function IconGWP1({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <title>GWP 1</title>
      <path
        fill="currentColor"
        d="M23.06 9.663h-.95c.154-.275.25-.587.25-.924 0-1.035-.493-2.018-1.284-2.565a2.312 2.312 0 00-2.19-.268c-1.042.394-1.815.99-2.44 1.631a2.412 2.412 0 00-1.178-.316c-.465 0-.896.137-1.266.364a6.45 6.45 0 00-2.773-1.757 2.415 2.415 0 00-2.213.359c-.77.56-1.247 1.539-1.247 2.552 0 .337.095.649.248.924H5.5v5.697h.813V23.5h17.094V15.36h.814V9.663h-1.16zm-7.4-1.216c.395.128.702.44.826.836.004.012.013.021.016.033h-2.469a1.28 1.28 0 01.733-.82c.156-.068.321-.115.502-.115.137 0 .269.026.393.066zm.89 13.893h-2.564V10.823h2.564V22.34zm2.746-15.35a1.17 1.17 0 011.121.138c.475.329.782.96.782 1.611 0 .414-.337.75-.75.75h-2.756a2.422 2.422 0 00-.384-1.16c.528-.537 1.152-1.022 1.987-1.338zm-9.597.135c.178-.13.438-.26.764-.26.127 0 .265.02.411.067a5.294 5.294 0 012.313 1.47 2.415 2.415 0 00-.344 1.088H9.68a.751.751 0 01-.75-.75c0-.65.295-1.27.77-1.615zM6.66 14.2v-3.377h6.166V14.2H6.66zm.814 8.14v-6.96h5.352v6.96H7.474zm14.773 0H17.71v-6.96h4.537v6.96zm.814-8.14H17.71v-3.377h5.35V14.2z"
      ></path>
    </Icon>
  );
}

export function IconGWP2({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <title>GWP 2</title>
      <path
        fill="currentColor"
        d="M21.61 9.663c.154-.275.25-.587.25-.924 0-1.035-.493-2.018-1.284-2.565a2.312 2.312 0 00-2.19-.268c-1.042.394-1.815.99-2.44 1.631a2.412 2.412 0 00-1.178-.316c-.465 0-.896.137-1.266.364a6.45 6.45 0 00-2.773-1.757 2.415 2.415 0 00-2.213.359c-.77.56-1.247 1.539-1.247 2.552 0 .337.095.649.248.924H5v5.697h.813V23.5h17.094V15.36h.814V9.663h-2.11zm-6.45-1.216c.395.128.702.44.826.836.004.012.013.021.016.033h-2.469a1.28 1.28 0 01.733-.82c.156-.068.321-.115.502-.115.137 0 .269.026.393.066zm.89 13.893h-2.564V10.823h2.564V22.34zm2.746-15.35a1.17 1.17 0 011.121.138c.475.329.782.96.782 1.611 0 .414-.337.75-.75.75h-2.756a2.422 2.422 0 00-.384-1.16c.528-.537 1.152-1.022 1.987-1.338zm-9.597.135c.178-.13.438-.26.764-.26.127 0 .265.02.411.067a5.294 5.294 0 012.313 1.47 2.415 2.415 0 00-.344 1.088H9.18a.751.751 0 01-.75-.75c0-.65.295-1.27.77-1.615zM6.16 14.2v-3.377h6.166V14.2H6.16zm.814 8.14v-6.96h5.352v6.96H6.974zm14.773 0H17.21v-6.96h4.537v6.96zm.814-8.14H17.21v-3.377h5.35V14.2zM4.738 25.082c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.116.116 0 00-.219.002 12.81 12.81 0 00-.08.233c-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 000-.227zM26.738 5.082c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.117.117 0 00-.219.001c-.033.093-.057.163-.08.234-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 000-.227z"
      ></path>
    </Icon>
  );
}

export function IconGWP3({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <title>GWP 3</title>
      <path
        fill="currentColor"
        d="M22.11 9.663c.154-.275.25-.587.25-.924 0-1.035-.493-2.018-1.284-2.565a2.312 2.312 0 00-2.19-.268c-1.042.394-1.815.99-2.44 1.631a2.412 2.412 0 00-1.178-.316c-.465 0-.896.137-1.266.364a6.45 6.45 0 00-2.773-1.757 2.415 2.415 0 00-2.213.359c-.77.56-1.247 1.539-1.247 2.552 0 .337.095.649.248.924H5.5v5.697h.813V23.5h17.094V15.36h.814V9.663h-2.11zm-6.45-1.216c.395.128.702.44.826.836.004.012.013.021.016.033h-2.469a1.28 1.28 0 01.733-.82c.156-.068.321-.115.502-.115.137 0 .269.026.393.066zm.89 13.893h-2.564V10.823h2.564V22.34zm2.746-15.35a1.17 1.17 0 011.121.138c.475.329.782.96.782 1.611 0 .414-.337.75-.75.75h-2.756a2.422 2.422 0 00-.384-1.16c.528-.537 1.152-1.022 1.987-1.338zm-9.597.135c.178-.13.438-.26.764-.26.127 0 .265.02.411.067a5.294 5.294 0 012.313 1.47 2.415 2.415 0 00-.344 1.088H9.68a.751.751 0 01-.75-.75c0-.65.295-1.27.77-1.615zM6.66 14.2v-3.377h6.166V14.2H6.66zm.814 8.14v-6.96h5.352v6.96H7.474zm14.773 0H17.71v-6.96h4.537v6.96zm.814-8.14H17.71v-3.377h5.35V14.2zM5.238 25.082c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.116.116 0 00-.219.002 12.81 12.81 0 00-.08.233c-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 000-.227zM25.323 4.224a.117.117 0 00-.085-.142c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.117.117 0 00-.219.001c-.033.093-.057.163-.08.234-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 00.085-.085zM28.671 5.634c-1.145-.29-1.438-1.128-1.673-1.805-.03-.088-.059-.171-.092-.258a.117.117 0 00-.219.001l-.083.24c-.238.703-.519 1.528-1.68 1.822a.117.117 0 000 .227c1.138.289 1.397 1.027 1.654 1.758l.11.306a.116.116 0 00.218-.001c.039-.104.073-.2.106-.297.259-.74.515-1.476 1.66-1.766a.117.117 0 000-.227z"
      ></path>
    </Icon>
  );
}

export function IconGWP4({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <title>GWP 4</title>
      <path
        fill="currentColor"
        d="M21.61 9.663c.154-.275.25-.587.25-.924 0-1.035-.493-2.018-1.284-2.565a2.312 2.312 0 00-2.19-.268c-1.042.394-1.815.99-2.44 1.631a2.412 2.412 0 00-1.178-.316c-.465 0-.896.137-1.266.364a6.45 6.45 0 00-2.773-1.757 2.415 2.415 0 00-2.213.359c-.77.56-1.247 1.539-1.247 2.552 0 .337.095.649.248.924H5v5.697h.813V23.5h17.094V15.36h.814V9.663h-2.11zm-6.45-1.216c.395.128.702.44.826.836.004.012.013.021.016.033h-2.469a1.28 1.28 0 01.733-.82c.156-.068.321-.115.502-.115.137 0 .269.026.393.066zm.89 13.893h-2.564V10.823h2.564V22.34zm2.746-15.35a1.17 1.17 0 011.121.138c.475.329.782.96.782 1.611 0 .414-.337.75-.75.75h-2.756a2.422 2.422 0 00-.384-1.16c.528-.537 1.152-1.022 1.987-1.338zm-9.597.135c.178-.13.438-.26.764-.26.127 0 .265.02.411.067a5.294 5.294 0 012.313 1.47 2.415 2.415 0 00-.344 1.088H9.18a.751.751 0 01-.75-.75c0-.65.295-1.27.77-1.615zM6.16 14.2v-3.377h6.166V14.2H6.16zm.814 8.14v-6.96h5.352v6.96H6.974zm14.773 0H17.21v-6.96h4.537v6.96zm.814-8.14H17.21v-3.377h5.35V14.2zM4.738 25.082c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.116.116 0 00-.219.002 12.81 12.81 0 00-.08.233c-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 000-.227zM9.238 26.082c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.116.116 0 00-.219.002 12.81 12.81 0 00-.08.233c-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 000-.227zM1.83 11.745c.028.069.056.138.084.203.01.021.028.039.054.047.047.015.1-.006.118-.047.03-.07.055-.133.08-.197.197-.493.392-.98 1.265-1.173a.086.086 0 00.066-.059c.013-.042-.017-.086-.066-.096-.876-.194-1.098-.752-1.276-1.201-.024-.06-.046-.117-.07-.17a.086.086 0 00-.054-.047c-.048-.015-.1.006-.117.048l-.064.16c-.182.466-.395 1.014-1.28 1.21a.086.086 0 00-.067.058c-.013.042.017.086.066.097.868.191 1.066.682 1.262 1.167zM24.823 4.224a.117.117 0 00-.085-.142c-1.116-.283-1.4-1.1-1.627-1.757l-.089-.25a.117.117 0 00-.219.001c-.033.093-.057.163-.08.234-.233.684-.505 1.486-1.634 1.772a.117.117 0 000 .227c1.106.28 1.358.998 1.608 1.709.035.1.07.2.107.297.012.03.036.056.068.068a.117.117 0 00.15-.069c.038-.101.071-.195.104-.288.25-.72.5-1.435 1.612-1.717a.117.117 0 00.085-.085zM28.171 5.634c-1.145-.29-1.438-1.128-1.673-1.805-.03-.088-.059-.171-.092-.258a.117.117 0 00-.219.001l-.083.24c-.238.703-.519 1.528-1.68 1.822a.117.117 0 000 .227c1.138.289 1.397 1.027 1.654 1.758l.11.306a.116.116 0 00.218-.001c.039-.104.073-.2.106-.297.259-.74.515-1.476 1.66-1.766a.117.117 0 000-.227z"
      ></path>
    </Icon>
  );
}

export function IconBag({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="20"
      width="20"
      viewBox="0 0 20 20"
    >
      <title>Bag</title>
      <path
        fill="currentColor"
        d="M18.231 7.646a2.035 2.035 0 00-1.548-.714h-2.234V5.234c0-2.508-2.04-4.549-4.55-4.549s-4.548 2.041-4.548 4.55v1.697H3.117a2.035 2.035 0 00-2.012 2.355l1.2 7.599a3.475 3.475 0 003.45 2.947h8.29a3.476 3.476 0 003.45-2.947l1.2-7.6a2.034 2.034 0 00-.464-1.64zM6.981 5.234c0-1.61 1.309-2.92 2.919-2.92s2.92 1.31 2.92 2.92v1.698H6.98V5.234zm8.905 11.398a1.856 1.856 0 01-1.84 1.572H5.754a1.854 1.854 0 01-1.84-1.572l-1.2-7.6c-.025-.16.048-.274.094-.327s.146-.143.31-.143h13.565c.163 0 .263.09.31.143s.117.166.092.328l-1.2 7.599z"
      ></path>
    </Icon>
  );
}

export function IconClose({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke}
      height="20"
      width="20"
      viewBox="0 0 20 20"
    >
      <title>Close</title>
      <path
        fill="currentColor"
        d="M11.06 10l5.47-5.47a.75.75 0 10-1.06-1.06L10 8.94 4.53 3.47a.75.75 0 10-1.06 1.06L8.94 10l-5.47 5.47a.75.75 0 101.06 1.06L10 11.06l5.47 5.47a.747.747 0 001.06 0 .75.75 0 000-1.06L11.06 10z"
      ></path>
    </Icon>
  );
}

export function IconMinus({ fill, ...props }) {
  return (
    <Icon
      {...props}
      fill={fill || 'currentColor'}
      height="2"
      width="12"
      viewBox="0 0 12 2"
    >
      <title>Minus</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.5L8.74228e-08 1.5L0 0.5L12 0.499999L12 1.5Z"
        fill={fill}
      />
    </Icon>
  );
}

export function IconPlus({ fill, ...props }) {
  return (
    <Icon
      {...props}
      fill={fill || 'currentColor'}
      height="12"
      width="12"
      viewBox="0 0 12 12"
    >
      <title>Plus</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.5L8.74228e-08 6.5L0 5.5L12 5.5L12 6.5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 12L5.5 -4.37114e-08L6.5 0L6.5 12L5.5 12Z"
        fill={fill}
      />
    </Icon>
  );
}

export function IconMinusRound({ fill, ...props }) {
  return (
    <Icon
      {...props}
      fill={fill || 'currentColor'}
      height="2"
      width="18"
      viewBox="0 0 18 2"
    >
      <title>Minus Round</title>
      <path
        id="Line"
        d="M1.69214 0.961426H16.6921"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
}

export function IconPlusRound({ fill, ...props }) {
  return (
    <Icon
      {...props}
      fill={fill || 'currentColor'}
      height="17"
      width="18"
      viewBox="0 0 18 17"
    >
      <title>Plus Round</title>
      <path
        id="Line"
        d="M1.69214 8.44238H16.6921"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        id="Line_2"
        d="M9.19214 15.9424L9.19214 0.942383"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
}

export function IconChevronLeft({ fill, ...props }) {
  return (
    <Icon
      {...props}
      fill={fill || 'currentColor'}
      height="8"
      width="13"
      viewBox="0 0 8 13"
    >
      <title>Chevron</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.09023 6.20652L7.27437 0.968804L6.44865 0.00126648L0.785682 5.72275C0.662047 5.84766 0.591797 6.02294 0.591797 6.20652C0.591797 6.39009 0.662047 6.56537 0.785682 6.69029L6.44865 12.4118L7.27437 11.4442L2.09023 6.20652Z"
        fill={fill}
      />
    </Icon>
  );
}

export function IconNext({ stroke, ...props }) {
  return (
    <Icon
      {...props}
      stroke={stroke || 'currentColor'}
      height="13"
      width="17"
      viewBox="0 0 17 13"
      fill={'transparent'}
    >
      <title>Arrow</title>
      <path
        d="M0.854492 6.57153L16.2831 6.57153"
        stroke={stroke}
        strokeWidth="1.42857"
        strokeLinejoin="round"
      />
      <path
        d="M11.1403 11.7144L16.2832 6.57157L11.1403 1.42871"
        stroke={stroke}
        strokeWidth="1.42857"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function IconAfterPay(props) {
  return (
    <Icon
      {...props}
      width="65"
      height="12"
      viewBox="0 0 54 10"
      fill="none"
    >
      <title>Afterpay</title>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.419 6.873v.696h1.363v-5.35H4.42v.674a2.24 2.24 0 00-1.717-.77C1.196 2.123 0 3.32 0 4.893c0 1.583 1.152 2.76 2.67 2.76.73 0 1.34-.298 1.749-.78zm-1.518-3.51c.83 0 1.506.632 1.506 1.53 0 .9-.675 1.53-1.506 1.531-.83 0-1.507-.653-1.507-1.53 0-.889.676-1.531 1.507-1.531z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M12.399 6.38c-.477 0-.61-.17-.61-.62V3.385h.876V2.218h-.875V.913h-1.396v1.305H8.596v-.325c0-.45.177-.62.665-.62h.306V.233h-.672C7.743.234 7.2.598 7.2 1.71v.508h-.775v1.166H7.2v4.184h1.396V3.384h1.799v2.622c0 1.091.431 1.563 1.561 1.563h.72V6.38H12.4z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.054 6.488c-.742 0-1.329-.45-1.429-1.241h4.244c.022-.108.033-.225.033-.343 0-1.605-1.196-2.782-2.847-2.782-1.64 0-2.88 1.166-2.88 2.782s1.174 2.75 2.846 2.75c1.384 0 2.437-.728 2.77-1.862h-1.43c-.265.428-.72.696-1.307.696zm-.022-3.189c.686 0 1.274.417 1.373 1.113h-2.768c.143-.707.708-1.113 1.395-1.113zM24.753 2.218h-1.362V9.77h1.407V6.938c.398.449.974.717 1.672.717 1.507 0 2.703-1.2 2.703-2.772 0-1.572-1.174-2.76-2.67-2.76-.73 0-1.34.299-1.75.791v-.696zm1.519 1.145c.83 0 1.506.664 1.506 1.53 0 .867-.676 1.53-1.506 1.531-.83 0-1.507-.653-1.507-1.53 0-.889.676-1.531 1.507-1.531zM34.095 6.873v.696h1.362v-5.35h-1.362v.674a2.24 2.24 0 00-1.717-.77c-1.506 0-2.703 1.197-2.703 2.77 0 1.583 1.152 2.76 2.67 2.76.73 0 1.34-.298 1.75-.78zm-1.519-3.51c.831 0 1.507.632 1.507 1.53 0 .9-.675 1.53-1.507 1.531-.83 0-1.506-.653-1.506-1.53 0-.889.676-1.531 1.506-1.531z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M20.936 2.743s.347-.62 1.196-.62c.363 0 .598.12.598.12v1.365s-.513-.306-.983-.244c-.471.061-.769.48-.767 1.038v3.167h-1.407V2.22h1.363v.524zM41.819 2.218l-3.44 7.535h-1.45l1.35-2.913-2.283-4.622h1.644l1.336 3.088 1.37-3.088h1.473zM52.798 2.097l-3.41-1.9c-1-.559-2.252.139-2.252 1.255v.195c0 .177.098.34.255.427l.644.36c.19.105.425-.027.425-.238v-.485c0-.242.272-.394.489-.273l2.953 1.647a.31.31 0 010 .545l-2.953 1.647c-.217.121-.489-.03-.489-.273v-.258c0-1.117-1.25-1.815-2.252-1.256l-3.41 1.9c-1.001.559-1.001 1.955 0 2.513l3.41 1.9c1 .559 2.252-.139 2.252-1.255v-.195a.49.49 0 00-.255-.427l-.644-.36c-.189-.106-.425.026-.425.237v.485c0 .242-.271.394-.489.273l-2.953-1.647a.31.31 0 010-.546l2.953-1.647c.218-.12.49.03.49.273v.258c0 1.117 1.25 1.815 2.251 1.256l3.41-1.9a1.425 1.425 0 000-2.51z"
      ></path>
    </Icon>
  );
}

export function IconKlarna(props) {
  return (
    <Icon
      {...props}
      width="36"
      height="10"
      viewBox="0 0 36 10"
      fill="none"
    >
      <title>Klarna Payment Badge</title>
      <path
        fill="currentColor"
        d="M27.884 4.86c.015 1.36.006 2.72.006 4.077 0 .318-.037.354-.363.354-.376.002-.754.002-1.131 0-.295 0-.328-.031-.328-.319 0-1.32.004-2.638-.004-3.957 0-.22-.03-.442-.07-.66-.058-.314-.271-.492-.575-.542-.553-.092-1.05.083-1.514.368-.061.038-.085.176-.085.268-.007 1.11-.005 2.22-.005 3.33 0 .418-.005.835.002 1.252.004.191-.08.265-.266.262-.418-.007-.835-.002-1.252-.003-.242-.002-.308-.07-.308-.316V2.676c0-.22.066-.29.288-.291.376-.004.752-.003 1.131-.001.239.001.28.046.285.283.002.091.01.181.016.326.123-.079.196-.122.268-.17.735-.499 1.551-.62 2.408-.469.784.137 1.212.662 1.37 1.407.08.361.123.732.127 1.1zm7.478-2.95l-.087.235c-.02.062-.038.115-.05.164-.015-.05-.03-.104-.05-.164l-.083-.235h-.08l-.033.486h.06l.013-.209c.005-.073.008-.155.01-.215.016.058.034.12.057.189l.079.232h.047l.086-.236c.024-.067.043-.128.06-.185h.002c0 .06.004.143.009.21l.011.214h.064l-.03-.486h-.085zM16.337 4.402c.04 1.538.032 3.079.041 4.619.001.205-.074.272-.285.274h-1.09c-.307 0-.345-.038-.361-.342-.002-.033-.008-.066-.016-.13-.207.115-.383.225-.568.315-.646.313-1.32.342-1.999.142-.611-.182-.986-.603-1.135-1.221a3.062 3.062 0 01-.028-1.339c.14-.688.604-1.07 1.25-1.263.624-.19 1.268-.21 1.913-.204.462.005.463.001.462-.467 0-.121.008-.245-.014-.362-.07-.378-.322-.613-.739-.613-.697 0-1.396.03-2.093.07-.342.02-.387.003-.387-.342 0-.243.005-.486-.001-.726-.003-.135.05-.228.178-.255 1.083-.23 2.171-.39 3.27-.117.99.243 1.575.932 1.602 1.96zm-1.773 3.122c-.017-.16-.004-.322-.004-.485 0-.208.008-.417-.006-.625-.003-.052-.075-.143-.112-.142-.42.015-.844.026-1.262.078a.576.576 0 00-.496.475c-.048.24-.062.492-.042.738.023.268.216.425.48.47.425.073.824-.01 1.22-.163.17-.065.243-.16.222-.346zm19.748-2.742c.003 1.4.002 2.8.001 4.2 0 .278-.035.31-.316.31h-1.05c-.3 0-.32-.018-.335-.311a.61.61 0 00-.012-.102c-.002-.013-.014-.02-.035-.052-.044.02-.084.033-.116.055-.469.35-1.008.486-1.58.53-1.134.093-2-.653-2.055-1.789-.013-.28-.02-.565.022-.84.103-.662.511-1.102 1.14-1.279.475-.133.973-.19 1.463-.247.286-.035.579-.01.868-.006.127.004.19-.04.183-.172-.01-.2.008-.405-.026-.603-.075-.442-.325-.671-.772-.67-.691.005-1.383.036-2.075.074-.347.019-.396-.009-.396-.366v-.666c-.001-.172.073-.268.25-.31.804-.18 1.616-.279 2.438-.227a4.08 4.08 0 011.021.207c.782.26 1.214.835 1.34 1.64.031.208.04.417.041.624zm-1.78 2.807c-.008-.183 0-.364-.002-.545 0-.193-.004-.39.003-.585.002-.132-.043-.2-.187-.193-.255.006-.512-.015-.766.005-.85.064-1.003.38-1.014 1.078-.006.411.186.633.513.689.454.074.878-.02 1.291-.203.113-.05.168-.118.163-.246zM9.585 0h-1.17c-.294.001-.321.03-.321.327v8.679c0 .243.041.283.28.284.383.002.766 0 1.15 0 .361 0 .395-.031.395-.387V1.536.325C9.917.05 9.866.002 9.584 0zm24.993 1.962h.148v.433h.064v-.433h.148V1.91h-.36v.053zm-13.605.34a2.57 2.57 0 00-1.425.494c-.059.043-.116.081-.203.144-.007-.097-.015-.154-.015-.212-.006-.29-.057-.344-.34-.344H17.9c-.333 0-.388.054-.388.385V8.926c0 .299.066.365.35.365.382.002.767.002 1.15 0 .31 0 .359-.046.359-.366 0-1.492.002-2.986-.003-4.482 0-.147.043-.231.179-.296.449-.21.91-.369 1.414-.348.185.007.275-.063.27-.258-.007-.33-.006-.66 0-.989 0-.18-.08-.257-.259-.25zM1.913.001a60.118 60.118 0 00-1.071 0C.469.009.262.223.262.598V8.977c0 .247.033.28.28.28.363.003.727.003 1.09 0 .381-.003.572-.193.572-.572V.305c.001-.245-.05-.3-.29-.303zm4.01 6.335A4.385 4.385 0 003.14 4.969c-.337-.006-.34-.006-.331.249.003.094.022.186.036.28.187 1.239.793 2.226 1.801 2.964.661.486 1.41.738 2.224.814.242.024.283.007.259-.23-.104-1.034-.48-1.952-1.204-2.71zM6.876.025c-.092.014-.188.009-.28.023-1.06.169-1.961.638-2.677 1.443A4.364 4.364 0 002.81 4.075c-.022.255-.008.256.261.29.37-.09.754-.146 1.107-.28 1.763-.67 2.728-1.97 2.95-3.834.029-.236-.01-.263-.254-.226z"
      ></path>
    </Icon>
  );
}

export function IconTooltip() {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle
        cx="10"
        cy="10"
        r="5.5"
        stroke="currentColor"
      ></circle>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.25 13h1.5V9h-1.5v4zM9.25 8h1.5V7h-1.5v1z"
        clipRule="evenodd"
      ></path>
    </Icon>
  );
}

export function IconRuler() {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      fill="none"
      viewBox="0 0 17 16"
    >
      <g
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        clipPath="url(#clip0_1710_62833)"
      >
        <path d="M4.955 15.333L15.62 4.667l-4-4L.955 11.333l1.132 1.134 2.868 2.866zM5.287 7L6.62 8.333M7.287 5L8.62 6.333M9.287 3l1.333 1.333M3.287 9l1.333 1.333"></path>
      </g>
      <defs>
        <clipPath id="clip0_1710_62833">
          <path
            fill="#fff"
            d="M0 0H16V16H0z"
            transform="translate(.287)"
          ></path>
        </clipPath>
      </defs>
    </Icon>
  );
}

export function IconGift({ stroke, ...props }) {
  return (
    <Icon
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3307 8.5V15.1667H2.66406V8.5"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6654 5.16699H1.33203V8.50033H14.6654V5.16699Z"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 15.166V5.16602"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9987 5.16634H4.9987C4.55667 5.16634 4.13275 4.99075 3.82019 4.67819C3.50763 4.36562 3.33203 3.9417 3.33203 3.49967C3.33203 3.05765 3.50763 2.63372 3.82019 2.32116C4.13275 2.0086 4.55667 1.83301 4.9987 1.83301C7.33203 1.83301 7.9987 5.16634 7.9987 5.16634Z"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.16634H11C11.442 5.16634 11.866 4.99075 12.1785 4.67819C12.4911 4.36562 12.6667 3.9417 12.6667 3.49967C12.6667 3.05765 12.4911 2.63372 12.1785 2.32116C11.866 2.0086 11.442 1.83301 11 1.83301C8.66667 1.83301 8 5.16634 8 5.16634Z"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function IconPlay(props) {
  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      className={props.classes}
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M20.642 12.821L7.29 6.145A.2.2 0 007 6.324v13.352a.2.2 0 00.29.18l13.352-6.677a.2.2 0 000-.358z"
      ></path>
    </Icon>
  );
}

export function IconPause(props) {
  return (
    <Icon
      width="24"
      height="24"
      className={props.classes}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M0 0H4V18H0z"
        transform="matrix(-1 0 0 1 10 3)"
      ></path>
      <path
        fill="currentColor"
        d="M0 0H4V18H0z"
        transform="matrix(-1 0 0 1 18 3)"
      ></path>
    </Icon>
  );
}
